module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "global--background",
    class: {
      'global--background-shrink': _vm.shrink
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "ctdit-news"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/ctdit/logo_ctdit2.png",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("CTDIT")]), _vm._v(" "), _c('div', [_vm._v("\n             Le CTDIT, unité du Service de Diabétologie - Maladies Métaboliques- Nutrition du CHU de Toulouse, a pour missions,\n             la conception, le développement et l’expérimentation\n             d’outils de télé-éducation et de télésurveillance dans le domaine de la diabétologie, nutrition et activité physique\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "tttto": "ctdit-news",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/chu/logo_lyon3.png",
      "height": "240px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Protocole Diamond-GLP1")]), _vm._v(" "), _c('div', [_vm._v("Diamond-GLP1 est un protocole visant à évaluer un nouveau traitement stimulant la sécrétion d’insuline\n            résiduelle de certains diabétiques de type 1.\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "diamond-news",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/news/LOGO_salutance50-2.png",
      "height": "150px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Salutance 5.0")]), _vm._v(" "), _c('div', [_vm._v("Le programme SALUTANCE 5.0 a pour objectif d’aider les personnes de 45 à 55 ans en surpoids ou obèses,\n            à modifier leurs habitudes de vie et à perdre du poids\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "href": "https://www.salutance.fr",
      "target": "_blank",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "/tools"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/ctdit/calculator.jpg",
      "height": "150px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Outils divers")]), _vm._v(" "), _c('div', [_vm._v("\n            Vous trouverez ici différents outils permettant de "), _c('a', {
    attrs: {
      "href": "#/imc"
    }
  }, [_vm._v("calculer votre IMC")]), _vm._v(",\n            d'évaluer votre activité physique, et bien d'autres\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/tools",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "/nutrikiosk"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/malnutrition/malnutrition.jpg",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("NutriKiosk : pour comprendre la nutrition en s'amusant")]), _vm._v(" "), _c('div', [_vm._v("\n             Cette application développée par le CTDIT permet d'enrichir ses connaissances\n             en nutrition de façon ludique\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/nutrikiosk",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/news/Icon1024x1024.png",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Educ@dom")]), _vm._v(" "), _c('div', [_vm._v("Le dispositif de télésurveillance proposé à des patients diabétiques de type 2 à leur domicile associe trois logiciels\n            d’éducation et des capteurs de données biomédicales \n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "news-educadom",
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("En savoir plus...")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cbebc00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/NutrieducNews.vue
// module id = 1207
// module chunks = 1